import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const fetchShow = createAsyncThunk('showSlice/fetchShow', async () => {
    const res = await fetch(`${process.env.REACT_APP_PROJECTS_API}components/s_d.php?show`)
    const data = await res.json()
    return data;
})

const showSlice = createSlice({
    initialState: {
        show: [],
        loading: false,
        error: null,
    },
    name: 'showSlice',
    extraReducers: (builder) => {
        builder
            .addCase(fetchShow.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchShow.fulfilled, (state, action) => {
                state.loading = false;
                state.show = action.payload;
            })
            .addCase(fetchShow.rejected, (state, action) => {
                state.loading = false;
                state.error = <p className='error-api'>The server is temporarily down Please try later!</p>;
            });
    },
})

export const { } = showSlice.actions;

export default showSlice.reducer;